import { useState } from "react";
import cx from "clsx";
import classes from "../../../Styles/TableScrollArea.module.css";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  Badge,
  Box,
  Button,
  Center,
  Checkbox,
  Divider,
  Flex,
  ScrollArea,
  Table,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

const SyncItem = ({
  listItem,
  onSuccess,
}: {
  listItem: any[];
  onSuccess: any;
}) => {
  const [dataSubmit, setDataSubmit] = useState<any[]>(listItem);
  const [scrolled, setScrolled] = useState(false);

  const handleCheckboxChange = (index: number) => {
    const updatedList = [...dataSubmit];
    updatedList[index].isCheckBox = !updatedList[index].isCheckBox;
    setDataSubmit(updatedList);
  };

  const handleSyncItem = async () => {
    const listItemCode = dataSubmit
      ?.filter((item) => item.isCheckBox)
      ?.map((item) => item.iteM_CODE);
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/ItemComparison/push-to-web",
      {
        itemCodes: listItemCode,
      }
    );

    if (res && res.success) {
      NotificationExtension.Success("Đồng bộ sản phẩm thành công !");
      setTimeout(() => {
        modals.closeAll();
        onSuccess((prev: boolean) => !prev);
      }, 1000);
    }
  };

  return (
    <Box w={"82.5vw"} maw={1250}>
      <Center mt={10}>
        <Text fw={500} size="20px">
          Bạn có chắc chắn muốn đồng bộ các sản phẩm này lên Web Admin ?
        </Text>
      </Center>
      <Divider
        my="xs"
        label={<Badge color={"green"}>Danh sách sản phẩm</Badge>}
        labelPosition="center"
      />
      <ScrollArea
        h={listItem.length <= 17 ? 90 + (listItem?.length - 1) * 35 : 650}
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      >
        <Table
          striped
          highlightOnHover
          withTableBorder
          withColumnBorders
          mt={10}
        >
          <Table.Thead
            className={cx(classes.header, {
              [classes.scrolled]: scrolled,
            })}
          >
            <Table.Tr>
              <Table.Th></Table.Th>
              <Table.Th>Mã sản phẩm</Table.Th>
              <Table.Th>Tên sản phẩm</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {dataSubmit?.map((item, index) => (
              <Table.Tr key={index}>
                <Table.Td>
                  <Tooltip label={item.isCheckBox ? "Bỏ chọn" : "Chọn"}>
                    <Checkbox
                      checked={item.isCheckBox}
                      onClick={() => handleCheckboxChange(index)}
                    />
                  </Tooltip>
                </Table.Td>
                <Table.Td>{item.iteM_CODE}</Table.Td>
                <Table.Td>{item.iteM_NAME}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </ScrollArea>
      <Flex justify={"flex-end"}>
        <Button
          mt={listItem?.length <= 17 ? 0 : 10}
          leftSection={<IconCheck size={20} />}
          color={"teal"}
          variant="outline"
          onClick={() => handleSyncItem()}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default SyncItem;
